module.exports = __webpack_public_path__ + "c06db3a760af367f55d2c2f7856ca8f3.svg";